import { useMemo } from "react";
import { useWidgetMargin } from "./useWidgetMargin";

export function useWidgetLayout(
  unitSize: number,
  widget: { h: number; w: number }
) {
  const margin = useWidgetMargin();

  return useMemo(
    () => ({
      width: unitSize * widget.w - margin * 2,
      height: unitSize * widget.h - margin * 2,
      unitSize,
      h: widget.h,
    }),
    [margin, unitSize, widget.h, widget.w]
  );
}
